import { ApplicationEnum } from "~/@types/enums";
import { FeatureFlagName } from "~/gql/graphqlBase.generated";

type ModuleEnabledMap = Partial<Record<string, boolean>>;

const moduleFeatureFlags: Readonly<Partial<Record<ApplicationEnum, FeatureFlagName>>> = {
	[ApplicationEnum.AVAILABILITY]: FeatureFlagName.AvailabilityApp,
	[ApplicationEnum.BENCHMARK]: FeatureFlagName.GrowerBenchmarks,
	[ApplicationEnum.COUNT]: FeatureFlagName.CountApp,
	[ApplicationEnum.ENGAGE]: FeatureFlagName.Engage,
	[ApplicationEnum.EVENTS]: FeatureFlagName.EventsApp,
	[ApplicationEnum.FORECAST]: FeatureFlagName.Forecast,
	[ApplicationEnum.INTELLIGENCE]: FeatureFlagName.Intelligence,
	[ApplicationEnum.MATERIAL]: FeatureFlagName.MaterialApp,
	[ApplicationEnum.PORTAL]: FeatureFlagName.CustomerPortal,
	[ApplicationEnum.PRODUCE]: FeatureFlagName.Produce,
	[ApplicationEnum.RESTOCK]: FeatureFlagName.Restock,
	[ApplicationEnum.VERIFY]: FeatureFlagName.Verify
};

export type { ModuleEnabledMap };

export default moduleFeatureFlags;
